import React from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
//import ARWorkspace from "./components/ar3d/ar/ARWorkspace";
import ThreeDWorkspace from "./components/ar3d/threeD/ThreeDWorkspace";
import SqftCanvasContainer from "./components/canvas/core/SqftCanvasContainer";
import {SQFT_VIEW_MODE} from "./constants";
import useImportSQFTData from "./hocs/onLoad/useImportSQFTData";
//import useUpdateSlabFeatures from "./hocs/onLoad/useUpdateSlabFeatures";
import ARWorkspaceSeparateModels from "./components/ar3d/ar/ARWorkspaceSeparateModels";
import useUpdateEditedFeatures from "./hocs/onLoad/useUpdateEditedFeatures";
import useUpdateShapesIntersections from "./hocs/onLoad/useUpdateIntersections";

const SquareFootageToolViewWorkspace = (props) => {
  const { SQFTViewMode, visualizersLoaded } = props;
  useImportSQFTData(visualizersLoaded);
  useUpdateShapesIntersections(visualizersLoaded);
  useUpdateEditedFeatures();
  //useUpdateSlabFeatures(visualizersLoaded);

  const getWorkspace = () => {
    switch (SQFTViewMode) {
      case SQFT_VIEW_MODE.threeDMode:
      case SQFT_VIEW_MODE.threeDModeFrameless:
        return <ThreeDWorkspace />
      case SQFT_VIEW_MODE.threeDModeDoors:
        return <ThreeDWorkspace displayDoorsOnly={true}/>
      case SQFT_VIEW_MODE.threeDModeFramed:
        return <ThreeDWorkspace shouldDisplayFramedDoors={true}/>
      case SQFT_VIEW_MODE.augmentedReality:
      case SQFT_VIEW_MODE.augmentedRealityCabinet:
        return <ARWorkspaceSeparateModels />
        //return <ARWorkspace/>
      case SQFT_VIEW_MODE.augmentedRealityDoorsOnly:
        return <ARWorkspaceSeparateModels displayDoorsOnly={true} />
        //return <ARWorkspace displayDoorsOnly={true}/>
      case SQFT_VIEW_MODE.twoDMode:
      default:
        return <SqftCanvasContainer/>
    }
  }

  return getWorkspace()
};

const mapStateToProps = (store) => {

  return {
    SQFTViewMode: store.sqftState.SQFTViewMode,
    visualizersLoaded: store.serverState.visualizersLoaded,
  };
};

const mapDispatchToProps = {
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(SquareFootageToolViewWorkspace)
);
